import React, { useEffect, useState } from 'react';
import { BaseWizardProps } from '../wizard/wizard-step-base';
import { GoAButton, GoAButtonGroup, GoASpacer } from '@abgov/react-components';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';

interface CurrentAtLocationProps extends BaseWizardProps { }

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

export const CurrentAtLocationComponent = ({
  navigationConfiguration,
}: CurrentAtLocationProps) => {
  const dispatch = useAppDispatch();

  const [nextPage, setNextPage] = useState('');

  const navigate = (selection: string) => {
    let pageConfig = 'error';

    if (selection.toLowerCase() == 'yes') {
      pageConfig = navigationConfiguration.pagingConfiguration.find(
        (item) => item.yes !== undefined,
      )!.yes;
    } else if (selection.toLocaleLowerCase() == 'no') {
      pageConfig = navigationConfiguration.pagingConfiguration.find(
        (item) => item.no !== undefined,
      )!.no;
    }

    setNextPage(pageConfig);
  };

  useEffect(() => {
    if (nextPage) navigationConfiguration.navigate(nextPage);
  }, [nextPage]);

  return (
    <div>
      <h2 className="location-screen">
        Are you currently at the collision location?
      </h2>
      <GoASpacer vSpacing={'l'} />
      Report My Collision online service can identify your collision location
      and auto populate the collision address using your device's location
      services.
      <GoASpacer vSpacing={'l'} />
      <GoAButtonGroup alignment="start" gap="relaxed">
        <GoAButton
          type="secondary"
          onClick={() => {
            navigate('yes');
          }}
        >
          Yes
        </GoAButton>
        <GoAButton
          type="secondary"
          onClick={() => {
            navigate('no');
          }}
        >
          No
        </GoAButton>
      </GoAButtonGroup>
      <GoASpacer vSpacing={'xl'} />
    </div>
  );
};

export default CurrentAtLocationComponent;
